import { SOH_SETTINGS, EARNING_CODES } from "../../types";

const SOHSettings = (state = {}, action) => {
    if ([SOH_SETTINGS, EARNING_CODES].includes(action.type)) state = { ...state, [action.type]: action.payload };
    return state;
};

export default SOHSettings;